// AxiosBaseService.ts
import axios from 'axios';

export default class AxiosBaseService {
  serverUrl = '/api/v1';

  constructor() {
    axios.defaults.withCredentials = true;
  }

  // 保持原本簽名與行為：回傳純 headers（不要把 withCredentials 放進來）
  buildHeaders(headers: {}, options: { authToken?: string; responseType?: any } = {}) {
    if (options && options.authToken) {
      return Object.assign(headers, {
        Authorization: `Bearer ${options.authToken}`,
      });
    }
    return headers;
  }

  // 小工具：在不改外部呼叫的前提下，把 withCredentials/responseType 放到 config
  private buildConfig(headers: any, options?: { responseType?: any }) {
    const config: any = { headers, withCredentials: true };
    if (options && options.responseType) {
      config.responseType = options.responseType; // e.g. 'blob'
    }
    return config;
  }

  get(url: string, options?: any) {
    const headers = this.buildHeaders({ Accept: 'application/json' }, options || {});
    return axios.get(url, this.buildConfig(headers, options));
  }

  post(url: string, data: any, options?: any, contentType?: string) {
    const headers = this.buildHeaders(
      {
        Accept: 'application/json',
        'Content-Type': contentType ?? 'application/json',
      },
      options || {}
    );
    return axios.post(url, data, this.buildConfig(headers, options));
  }

  delete(url: string, options?: any) {
    const headers = this.buildHeaders(
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      options || {}
    );
    return axios.delete(url, this.buildConfig(headers, options));
  }

  deleteWithBody(url: string, body: any, options?: any) {
    const headers = this.buildHeaders(
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      options || {}
    );
    // axios.delete 的 body 要放在 config.data
    const config = this.buildConfig(headers, options);
    config.data = body;
    return axios.delete(url, config);
  }

  options(url: string, options?: any) {
    const headers = this.buildHeaders({ Accept: 'application/json' }, options || {});
    return axios.options(url, this.buildConfig(headers, options));
  }

  put(url: string, data: any, options?: any, contentType?: string) {
    const headers = this.buildHeaders(
      {
        Accept: 'application/json',
        'Content-Type': contentType ?? 'application/json',
      },
      options || {}
    );
    return axios.put(url, data, this.buildConfig(headers, options));
  }

  patch(url: string, data: any, options?: any, contentType?: string) {
    const headers = this.buildHeaders(
      {
        Accept: 'application/json',
        'Content-Type': contentType ?? 'application/json',
      },
      options || {}
    );
    return axios.patch(url, data, this.buildConfig(headers, options));
  }
}
